export default __webpack_public_path__ + "static/media/XRTL_Manual_Fig_1.b1dc7877.png";